module.exports = __webpack_public_path__ + "static/media/ReturnTracking2.994aefc4.png";